import { Divider, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PhotoContainer from "../../Components/PhotoContainer/PhotoContainer";
import { useTranslation } from "react-i18next";
import { API } from "../../utils/http";
import { getApplicationAsync } from "../../redux/user/userSlice";

export default function Review(props) {
	const { handleNext, handleBack, renderControls } = props;
	const dispatch = useDispatch();
	const application = useSelector((state) => state.user.application);
	const email = useSelector((state) => state.auth.currentAuthenticatedUser?.email);
	const selfie = useSelector((state) => state.user.application.selfie);
	const id1 = useSelector((state) => state.user.application.id1);
	const id2 = useSelector((state) => state.user.application.id2);
	const groupId = useSelector((state) => state.user.application.personalInformation.idVerificationData);
	const { t } = useTranslation();

	const [id1VerificationResult, setId1VerificationResult] = useState(null);
	const [id2VerificationResult, setId2VerificationResult] = useState(null);

	const parseVerificationData = (data) => {
		if (!data) return {};
		if (typeof data === "object") return data;
		try {
			return JSON.parse(data);
		} catch {
			return {};
		}
	};

	const getGroupId = (verificationData, idType) => {
		if (verificationData[idType]?.group_id) {
			return verificationData[idType].group_id;
		}
		// Legacy format: { group_id: "..." } treated as id1
		if (idType === "id1" && verificationData.group_id) {
			return verificationData.group_id;
		}
		return null;
	};

	// Refresh application from DB on mount to get the latest idVerificationData
	useEffect(() => {
		dispatch(getApplicationAsync());
	}, []);

	useEffect(() => {
		console.log(application);
	}, [application]);

	useEffect(() => {
		const verificationData = parseVerificationData(groupId);
		const id1GroupId = getGroupId(verificationData, "id1");
		const id2GroupId = getGroupId(verificationData, "id2");

		if (id1GroupId) {
			API.get(`nexus2ai/verify/${id1GroupId}`)
				.then((r) => {
					console.log("ID1 verification result:", r.data.payload);
					setId1VerificationResult(r.data.payload);
				})
				.catch((e) => {
					console.error("Failed to fetch ID1 verification result:", e);
				});
		}

		if (id2GroupId) {
			API.get(`nexus2ai/verify/${id2GroupId}`)
				.then((r) => {
					console.log("ID2 verification result:", r.data.payload);
					setId2VerificationResult(r.data.payload);
				})
				.catch((e) => {
					console.error("Failed to fetch ID2 verification result:", e);
				});
		}
	}, [groupId]);
	return (
		<React.Fragment>
			<Typography variant="h6" color="secondary" fontWeight={"bold"} marginBottom={3}>
				{t("Review Information")}
			</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Full Name")}:
					</Typography>
					<Typography fontWeight={"bold"}>
						{application.personalInformation.firstName} {application.personalInformation.middleName} {application.personalInformation.lastName}
					</Typography>
				</Grid>
				{/* <Grid item xs={12} sm={6}>
          <Typography component="h6" fontWeight={"bold"} color="primary">
            Maiden Name:
          </Typography>
          <Typography fontWeight={"bold"}>
            {application.personalInformation.maidenName}
          </Typography>
        </Grid> */}
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Last at Birth Label")}:
					</Typography>
					<Typography fontWeight={"bold"}>{application.personalInformation.lastNameAtBirth || "-"}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Gender")}
					</Typography>
					<Typography fontWeight={"bold"} textTransform="capitalize">
						{application.personalInformation.gender}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Date of Birth")}:
					</Typography>
					<Typography fontWeight={"bold"}>{moment.utc(application.personalInformation.birthDate).format("MMM DD YYYY")}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Email")}:
					</Typography>
					<Typography fontWeight={"bold"}>{email}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Phone Number")}:
					</Typography>
					<Typography fontWeight={"bold"}>{application.personalInformation.phoneNumber}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Place of Birth")}:
					</Typography>
					<Typography fontWeight={"bold"}>
						{application.personalInformation.birthCity}, {application.personalInformation.birthCountryCode}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Criminal Offences")}:
					</Typography>
					<Typography fontWeight={"bold"}>{application.previousOffences ? "Yes" : "None"}</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Addresses")}:
					</Typography>

					<ul style={{ listStyle: "none", paddingLeft: "10px", margin: "0" }}>
						{application.addressInformation?.map((a, index) => {
							return (
								<li key={index}>
									<Typography fontWeight={"bold"}>
										{a.streetLine1}, {a.streetLine2 ? `${a.streetLine2}, ` : ""} {a.city}, {a.province}, {a.postalCode}, {a.country} from{" "}
										{moment.utc(a.dateMoveIn).format("MMM DD YYYY")}
										{a.dateMoveOut ? `to ${moment.utc(a.dateMoveOut).format("MMM DD YYYY")}` : ""}
									</Typography>
								</li>
							);
						})}
					</ul>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Selfie")}:
					</Typography>
					<Box style={{ position: "relative" }} sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
						<div
							style={{
								background: "rgba(0,0,0,0.2)",
								border: " 2px solid black",
								position: "absolute",
								width: "175px",
								transform: "translate(-50%,-50%)",
								top: "50%",
								left: "50%",
								zIndex: 100,
								borderRadius: "50%",
								maxWidth: "100%",
								aspectRatio: "1/1",
							}}
						></div>
						<PhotoContainer src={selfie} />
					</Box>
				</Grid>
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("First ID Front")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id1.front} />
							</Box>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("First ID Back")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id1.back} />
							</Box>
						</Grid>
						{id1VerificationResult && (
							<Grid item xs={12}>
								<Typography component="h6" fontWeight={"bold"} color="primary">
									{t("First ID")} AI Verification:
								</Typography>
								<Typography fontWeight={"bold"}>
									{id1VerificationResult.processing_status || "-"}
									{id1VerificationResult.result?.status ? ` / ${id1VerificationResult.result.status}` : ""}
								</Typography>
							</Grid>
						)}
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("Second ID Front")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id2.front} />
							</Box>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("Second ID Back")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id2.back} />
							</Box>
						</Grid>
						{id2VerificationResult && (
							<Grid item xs={12}>
								<Typography component="h6" fontWeight={"bold"} color="primary">
									{t("Second ID")} AI Verification:
								</Typography>
								<Typography fontWeight={"bold"}>
									{id2VerificationResult.processing_status || "-"}
									{id2VerificationResult.result?.status ? ` / ${id2VerificationResult.result.status}` : ""}
								</Typography>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
			{/* <div>
				<Typography component="h6" fontWeight={"bold"} color="primary">
					Full name:
				</Typography>
				<Typography fontWeight={"bold"}>
					{application.personalInformation.firstName} {application.personalInformation.middleNames} {application.personalInformation.lastName}
				</Typography>
			</div>
			<div>
				<Typography component="h6">Date of birth: </Typography>
				{application.personalInformation.dateOfBirth}
			</div>
			<div>
				<Typography component="h6">Email: </Typography>
				{email}
			</div>
			<div>
				<Typography component="h6">Telephone: </Typography>
				{application.personalInformation.phoneNumber}
			</div>
			<div>
				<Typography component="h6">Place of birth: </Typography>
				{application.personalInformation.birthCity}, {application.personalInformation.birthCountryCode}
			</div>
			<div>
				<Typography component="h6">Addresses: </Typography>
				<ul style={{ listStyle: "none", paddingLeft: "10px", margin: "0" }}>
					{application.addressInformation?.map((a, index) => {
						return (
							<li key={index}>
								{a.streetLine1}, {a.streetLine2}, {a.city}, {a.province},{a.postalCode},{a.country} from {a.dateMovedIn} to {a.dateMovedOut}
							</li>
						);
					})}
				</ul>
			</div>
			<div>
				<Typography component="h6">Criminal Offences: </Typography>

				{application.previousOffences ? "Yes" : "None"}
			</div> */}
			<Divider style={{ margin: "25px 0px" }} />
			<Typography>{t("Please review these details carefully.")}</Typography>
			{renderControls(handleNext, handleBack)}
		</React.Fragment>
	);
}